export default "__VITE_ASSET__BrSFOUmn__"